import React, { useRef } from 'react'
import style from './footer.mod.scss'
import { Button, Input } from '@components'
import Facebook from '@svgs/facebook.svg'
import { useStaticQuery, graphql } from 'gatsby'
import Instagram from '@svgs/instagram.svg'
import { gtmPush, postSend } from '@helpers/gtmHelpers'
import HubSpotForm from '../elements/hubspotForm'

const Footer = () => {
  const classes = [style.footer]
  const { site, global } = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          facebook
          instagram
          privacy
          terms
          dedikate
          contact
        }
      }

      global: datoCmsGlobal {
        zapierWebhookFooter
      }
    }
  `)

  const date = new Date()
  const year = date.getFullYear()

  const inputs = {
    type: useRef(null),
    email: useRef(null)
  }

  const formType = 'Footer Newsletter Sign Up'

  return (
    <footer className={classes.join(' ')}>
      <div className={style.footer__container}>
        <div className={style.footer__inner}>
          <h2>{'Stay Motivated'}</h2>
          <h4>{'Sign up for Weekly Motivation & Advice'}</h4>
          <div id="newsletter-signup">
            <HubSpotForm />
          </div>
          <div className={style.footer__links}>
            <div className={style.footer__social}>
              <a
                href={site.siteMetadata.facebook}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <Facebook />
              </a>
              <a
                href={site.siteMetadata.instagram}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <Instagram />
              </a>
            </div>
            <div className={style.footer__buttons}>
              <Button
                unstyled
                to={site.siteMetadata.dedikate}
                onClick={() => {
                  gtmPush({
                    event: `dedikate-click`,
                    label: `Footer Link`,
                    value: `Join DediKate`
                  })
                }}
              >
                {'Join DediKate'}
              </Button>
              <Button unstyled to={site.siteMetadata.contact}>
                {'Contact'}
              </Button>
              <Button unstyled to={site.siteMetadata.terms}>
                {'Terms'}
              </Button>
              <Button unstyled to={site.siteMetadata.privacy}>
                {'Privacy'}
              </Button>
            </div>
          </div>
          <div className={style.footer__info}>
            <p>{`© ${year} Kate Ivey Fitness`}</p>
            <p>
              {'Designed and Developed by'}{' '}
              <Button
                unstyled
                to={'https://www.harveycameron.nz/'}
                children={'Harvey Cameron'}
              />
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
